import { SvgIcon, SvgIconProps } from "@mui/material";

export function EuroIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path d="M10 14.133c-1.322 0-2.497-.377-3.525-1.133a6.18 6.18 0 0 1-2.192-2.9H2V8.7h1.967a1.617 1.617 0 0 1-.034-.317v-.625c0-.094.011-.202.034-.325H2v-1.4h2.283a6.18 6.18 0 0 1 2.192-2.9C7.503 2.378 8.678 2 10 2c.778 0 1.517.139 2.217.417A6.06 6.06 0 0 1 14.1 3.6l-1.25 1.25a4.615 4.615 0 0 0-1.325-.775A4.266 4.266 0 0 0 10 3.8c-.811 0-1.547.206-2.208.617-.661.41-1.17.95-1.525 1.616H10v1.4H5.8a2.293 2.293 0 0 0-.042.317 5.957 5.957 0 0 0 0 .633c.006.1.02.206.042.317H10v1.4H6.267a4.214 4.214 0 0 0 1.525 1.617c.66.41 1.397.616 2.208.616.533 0 1.047-.091 1.542-.275a3.923 3.923 0 0 0 1.291-.775l1.267 1.25a6.06 6.06 0 0 1-1.883 1.184c-.7.277-1.44.416-2.217.416z" />
    </SvgIcon>
  );
}
